import React, { useState, useEffect, useContext, useCallback } from 'react'
import { isEmpty, checkUserLogin } from 'AccountsUtils'
import './hifive.scss'
import PageLoader from 'Lib/Pageloader'
import { Spacer } from '@cleartrip/bento/components/Spacing'
import classNames from 'classnames'
import { AccountsContext } from 'AccountsContext'
import DesktopModal from '../../components/Desktop/DesktopModal'
import { triggerHiFiveClevertap } from './hiFiveClevertap'
import ActiveFlow from './ActiveFlow'
import InactiveFlow from './InactiveFlow'
import HifiveContent from './HifiveContent'
import FAQ from './FAQ'
import { getHiFiveDetails, saveHiFiveNudge } from '../../pages/Trips/trips.helper'
import ApiFailurePage from './ApiFailurePage'

const HiFive = () => {
  const [pageLoading, setPageLoading] = useState(true)
  const [apiFailure, setApiFailure] = useState(false)
  const [isTimerStart, setTimerStart] = useState(false)

  const { hifiveStates, setHifiveStates } = useContext(AccountsContext)

  const resultSeen = useCallback(
    async () => {
      const res = await saveHiFiveNudge()
      return res
    }, []
  )

  const parentClass = classNames('bg-hifive br-16 flex w-100p', {
    'flex-between flex-row-reverse': !hifiveStates?.isLanding,
    'p-relative': !isEmpty(hifiveStates?.statusValue),
    'bg-failure-hifive': hifiveStates?.isFailure,
    'bg-success-hifive': hifiveStates?.isSuccess,
    inactiveBg: hifiveStates?.isInactive
  })

  async function fetchHiFiveInfo() {
    // eslint-disable-next-line no-constant-condition
    try {
      const res = await getHiFiveDetails()
      if (res.status === 200 && !isEmpty(res.data)) {
        const {
          statusDetails,
          registeredReferrals,
          referralLinkDetails,
          referralProgramDetails
        } = res.data

        const config = referralProgramDetails?.stageConfig
        const rewardValuearr = config?.map(stage => stage.rewardValue)

        const expTime = referralLinkDetails?.expiresAt &&
        new Date(referralLinkDetails?.expiresAt).getTime()

        setHifiveStates(prevState => {
          let newState = {
            ...prevState,
            signedUpUsersList: registeredReferrals,
            referralLinkHifive: referralLinkDetails?.referralLink,
            rewardAmountHiFive: referralProgramDetails?.totalRewardAmount,
            requiredSignUpCountHiFIve: referralProgramDetails?.requiredSignUpCount,
            expiryTime: referralProgramDetails?.linkValidityInHrs,
            cycleExpirationTime: referralProgramDetails?.cycleExpiresAt,
            statusValue: statusDetails?.referralStatus,
            rewardProgressArray: rewardValuearr,
            linkExpirationTime: expTime,
            signupReward: referralProgramDetails?.referralSignupRewardAmount,
            cycleLength: referralProgramDetails?.cycleLengthInDays

          }

          if (referralLinkDetails?.linkStatus === 'ACTIVE' || isTimerStart) {
            newState = {
              ...newState,
              isRunning: true,
              isActiveHifive: true,
              isHifiveStart: true,
              isLanding: false,
              isSuccess: false,
            }
          }

          if (statusDetails?.eligibleForReferral) {
            newState = {
              ...newState,
              isLanding: true,
              isRunning: false,
              isSuccess: false,
            }
          }

          if (statusDetails?.referralStatus === 'SUCCESS') {
            newState = {
              ...newState,
              isRunning: false,
              isActiveHifive: false,
              isHifiveStart: true,
              isLanding: false,
              isSuccess: true
            }
          }

          if (statusDetails?.resultsViewed) {
            newState = {
              ...newState,
              isHifiveStart: true,
              isInactive: true,
              isRunning: false,
              isActiveHifive: false,
              isLanding: false,
              isSuccess: false,
              isFailure: false
            }
          }
          if (referralLinkDetails?.linkStatus === 'EXPIRED' &&
          statusDetails?.referralStatus !== 'SUCCESS' &&
          !statusDetails?.resultsViewed) {
            newState = {
              ...newState,
              isHifiveStart: true,
              isInactive: false,
              isRunning: false,
              isActiveHifive: false,
              isLanding: false,
              isSuccess: false,
              isFailure: true
            }
          }

          return newState
        })

        if (statusDetails?.referralStatus === 'SUCCESS' || referralLinkDetails?.linkStatus === 'EXPIRED') {
          resultSeen()
        }
        setPageLoading(false)
      } else if (res && (res.status !== 200)) {
        setApiFailure(true)
        setPageLoading(true)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const goHome = () => {
    window.location.href = '/'
  }
  useEffect(() => {
    if (!checkUserLogin()) {
      window.location.href = '/'
    } else {
      fetchHiFiveInfo()
    }

    triggerHiFiveClevertap(
      {
        logged_in: 'yes',
        page_name: 'Hi5_home',
        platform: 'Desktop',
        domain: 'cleartrip.com'
      },
      'Hi5_pageLoad'
    )
  }, [isTimerStart])

  return (

    <div
      className="pl-5 pt-5 hifive-container"
      style={{ borderLeft: '1px solid #ccc',
        boxShadow: '-4px 0px 8px #cccccc3b' }}
    >
      <If condition={pageLoading === true}>
        <PageLoader />
      </If>

      <If condition={pageLoading === false}>

        <div
          className={parentClass}
          style={{ width: '734px' }}
        >
          <div className={`flex flex-column pl-6 
          ${(hifiveStates?.isLanding ||
            hifiveStates?.isInactive ||
             hifiveStates?.isFailure) ? ' pr-6' : 'pr-14'}
          ${(!hifiveStates?.isRunning) ? 'flex-center' : ''}`
          }
          >
            <If condition={hifiveStates?.isRunning}>
              <Spacer className="pt-15" />
              <Spacer className="pt-15" />
              <Spacer className="pt-8" />
            </If>

            <div className="">

            </div>
          </div>

          <div className="flex">
            { (!hifiveStates?.isInactive && !hifiveStates?.isFailure) && (
              <ActiveFlow
                isTimerStart={isTimerStart}
                setTimerStart={setTimerStart}
                // rewardProgressArray={rewardProgressArray}
              />
            )}
            {(hifiveStates?.isInactive || hifiveStates?.isFailure) && (
              <InactiveFlow
                isInactiveFlow={hifiveStates?.isInactive}
                cycleExpirationTime={hifiveStates?.cycleExpirationTime}
                showHiFiveFailurePage={hifiveStates?.isFailure}
              />
            )}

          </div>

        </div>

        <HifiveContent
          rewardAmount={hifiveStates?.rewardAmountHiFive}
          requiredSignUpCountHiFIve={hifiveStates?.requiredSignUpCountHiFIve}
        />
        <FAQ
          rewardAmount={hifiveStates?.rewardAmountHiFive}
          requiredSignUpCountHiFIve={hifiveStates?.requiredSignUpCountHiFIve}
          expiryTime={hifiveStates?.expiryTime}
          cycleLength={hifiveStates?.cycleLength}
        />
        <div className="pt-12" />
      </If>
      <If condition={apiFailure}>
        <DesktopModal
          showFlag={true}
          className="hifive-modal"
          onCloseModal={() => goHome()}
        >
          <ApiFailurePage />
        </DesktopModal>
      </If>

    </div>
  )
}

export default HiFive
